document.addEventListener('DOMContentLoaded', function() {
  // 确保翻译函数可用
  if (typeof t !== 'function') {
    console.error('翻译函数未定义，请确保order-tracking-translations.js已加载');
    // 定义一个临时的t函数，避免错误
    window.t = function(key) {
      return key;
    };
  }
  
  // 初始化语言 - 优先使用用户之前选择的语言，其次是HTML lang属性
  try {
    // 首先检查用户是否之前手动选择了语言
    const savedLang = sessionStorage.getItem('selectedLanguage');
    if (savedLang && typeof translations !== 'undefined' && translations[savedLang]) {
      currentLang = savedLang;
     console.log(`使用用户之前选择的语言: ${currentLang}`);
    }
    // 如果没有保存的语言设置，再尝试其他方法
    else if (typeof detectLanguage === 'function') {
      currentLang = detectLanguage();
     console.log(`使用检测到的语言: ${currentLang}`);
    } else {
      // 直接检查HTML lang属性
      const htmlLang = document.documentElement.lang || document.body.getAttribute('lang');
      if (htmlLang && typeof translations !== 'undefined' && translations[htmlLang]) {
        currentLang = htmlLang;
       console.log(`从HTML lang属性设置语言: ${currentLang}`);
      } else if (typeof currentLang === 'undefined') {
        // 默认使用英语
        currentLang = 'en';
       console.log('未检测到语言设置，使用默认英语');
      }
    }
  } catch (e) {
    console.error('设置语言时出错:', e);
    // 确保currentLang有值
    if (typeof currentLang === 'undefined') {
      currentLang = 'en';
    }
  }
  
  // 选项卡切换功能
  const orderTab = document.getElementById('order-tab');
  const trackingTab = document.getElementById('tracking-tab');
  const orderContent = document.getElementById('order-content');
  const trackingContent = document.getElementById('tracking-content');
  const resultDiv = document.getElementById('result');
  const embeddedTracking = document.getElementById('embedded-tracking');
  
  // 追踪单号输入框和按钮
  const trackingInput = document.getElementById('YQNum');
  const trackButton = document.getElementById('trackButton');
  
  // 订单查询输入框和按钮
  const emailInput = document.getElementById('email');
  const orderInput = document.getElementById('orderName');
  const findOrderButton = document.getElementById('findOrderButton');
  
  // 初始化语言设置
  updateUILanguage();
  
  // 设置语言选择器的初始值
  const langSelect = document.getElementById('language-select');
  if (langSelect) {
    langSelect.value = currentLang;
  }
  
  // 订单选项卡点击事件
  orderTab.addEventListener('click', function() {
    orderTab.classList.add('active');
    trackingTab.classList.remove('active');
    orderContent.style.display = 'block';
    trackingContent.style.display = 'none';
  });
  
  // 追踪选项卡点击事件
  trackingTab.addEventListener('click', function() {
    trackingTab.classList.add('active');
    orderTab.classList.remove('active');
    trackingContent.style.display = 'block';
    orderContent.style.display = 'none';
  });
  
  // 追踪按钮点击事件
  trackButton.addEventListener('click', function() {
    doTrack();
  });
  
  // 查找订单按钮事件
  findOrderButton.addEventListener('click', function() {
    findOrder();
  });

  // 为所有输入框添加点击时全选内容的功能
  const allInputs = document.querySelectorAll('.track-input');
  allInputs.forEach(input => {
    input.addEventListener('click', function() {
      this.select();
    });
  });
  
// 从URL获取参数并自动查询订单
function checkUrlParams() {
  // 获取完整的URL包括hash部分
  const fullUrl = window.location.href;
  let email = null;
  let orderId = null;
  let trackingNumber = null;
  
  // 检查追踪号参数 (nums)
  const trackingMatch = fullUrl.match(/[?&]nums=([^&#]*)/);
  if (trackingMatch && trackingMatch[1]) {
    trackingNumber = decodeURIComponent(trackingMatch[1]);
  }
  
  // 如果存在追踪号参数，则切换到追踪选项卡并自动查询
  if (trackingNumber) {
   console.log('从URL参数中检测到追踪号:', trackingNumber);
    
    // 填充追踪号输入框
    const trackingInput = document.getElementById('YQNum');
    if (trackingInput) {
      trackingInput.value = trackingNumber;
    }
    
    // 切换到追踪选项卡
    const trackingTab = document.getElementById('tracking-tab');
    if (trackingTab) {
      trackingTab.click();
    }
    
    // 延迟执行追踪查询，确保页面已完全加载
    setTimeout(function() {
      doTrack();
    }, 500);
    
    return; // 如果有追踪号参数，不再继续检查订单参数
  }
  
  // 正则表达式匹配email参数
  const emailMatch = fullUrl.match(/[?&]email=([^&#]*)/);
  if (emailMatch && emailMatch[1]) {
    email = decodeURIComponent(emailMatch[1]);
  }
  
  // 正则表达式匹配orderid参数 (包括#符号)
  const orderMatch = fullUrl.match(/[?&]orderid=([^&]*)/);
  if (orderMatch && orderMatch[1]) {
    orderId = decodeURIComponent(orderMatch[1]);
  }
  
  // 备用：尝试其他可能的参数名
  if (!orderId) {
    const orderIdMatch = fullUrl.match(/[?&]order_id=([^&#]*)/);
    const orderMatch2 = fullUrl.match(/[?&]order=([^&#]*)/);
    
    if (orderIdMatch && orderIdMatch[1]) {
      orderId = decodeURIComponent(orderIdMatch[1]);
    } else if (orderMatch2 && orderMatch2[1]) {
      orderId = decodeURIComponent(orderMatch2[1]);
    }
  }
  
 console.log("检测到URL参数:", email, orderId);
  
  if (email && orderId) {
   console.log('从URL参数中检测到订单信息');
    emailInput.value = email;
    orderInput.value = orderId;
    
    // 延迟执行查询，确保页面已完全加载
    setTimeout(function() {
      findOrder();
    }, 500);
  }
}
  
  // 检查URL参数
  checkUrlParams();
  
  // 触发自定义事件，通知翻译模块主脚本已加载完成
  window.dispatchEvent(new Event('orderTrackingLoaded'));
});

// 查询订单功能
async function findOrder() {
  // 确保翻译函数可用
  if (typeof t !== 'function') {
    console.error('翻译函数未定义，请确保order-tracking-translations.js已加载');
    // 定义一个临时的t函数，避免错误
    window.t = function(key) {
      return key;
    };
  }
  
  const emailInput = document.getElementById('email');
  const orderInput = document.getElementById('orderName');
  const resultDiv = document.getElementById('result');
  const embeddedTracking = document.getElementById('embedded-tracking');
  
  const email = emailInput.value;
  const orderName = orderInput.value;
  
  if(!email || !orderName) {
    resultDiv.innerHTML = `<p class="error-message">${t('enterBothFields')}</p>`;
    return;
  }
  
  resultDiv.innerHTML = `<div class="loading-indicator">${t('searchingOrder')}</div>`;
  // 隐藏之前的追踪结果
  embeddedTracking.style.display = 'none';
  
  try {
    const response = await fetch('https://cheerfulpainting.cc/api/query-order', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: email,
        orderName: orderName,
        storeDomain: getShopifyInfo().domain // 使用函数获取商店域名
      }),
    });
    
    const data = await response.json();
   console.log("订单数据:", data);
    if (data && data.results && data.results.length > 0) {
      const order = data.results[0];
      
      // 检查是否用户已手动设置了语言
      const isManuallySelected = sessionStorage.getItem('manualLanguageSelection') === 'true';
      
      // 当订单数据返回后，仅在用户未手动设置语言时才根据订单的国家代码更新语言
      if (!isManuallySelected && order.shipping_address && order.shipping_address.country_code) {
        const countryCode = order.shipping_address.country_code.toLowerCase();
        // 根据国家代码映射到语言代码
        const countryToLang = {
          'us': 'en', 'gb': 'en', // 英语国家
          'cn': 'zh', 'hk': 'zh', 'tw': 'zh', // 中文国家/地区
          'fr': 'fr', 'ca': 'fr', // 法语国家
          'de': 'de', 'at': 'de', 'ch': 'de', // 德语国家
          'es': 'es', 'mx': 'es', // 西班牙语国家
          'fi': 'fi', // 芬兰
          'sk': 'sk', // 斯洛伐克
          'se': 'sv', // 瑞典
          'it': 'it', // 意大利
          'cz': 'cs', // 捷克
         'pl': 'pl', // 波兰
          'pt': 'pt', 'br': 'pt', // 葡萄牙和巴西
          // 可以添加更多国家映射
        };
        
        if (countryToLang[countryCode] && translations[countryToLang[countryCode]]) {
          currentLang = countryToLang[countryCode];
          updateUILanguage();
        }
      }
      
      let trackingNumber = null;
      let trackingButtonHtml = '';
      
      if (order.fulfillments && order.fulfillments.length > 0) {
        const fulfillment = order.fulfillments[0];
        trackingNumber = fulfillment.tracking_number;
      }
      
      // 创建新的美化版订单信息显示
      let orderInfoHTML = `
        <div class="order-info-card">
          <h3 class="order-info-title">${t('orderDetails')}</h3>
          
          <div class="order-table">
            <div class="order-table-header">
              <div class="product-col">${t('product')}</div>
              <div class="quantity-col">${t('quantity')}</div>
              <div class="total-col">${t('total')}</div>
              <div class="status-col">${t('status')}</div>
            </div>
      `;
      
      // 添加产品列表 - 表格样式
      if (order.line_items && order.line_items.length > 0) {
        // 为每个产品创建行
        order.line_items.forEach((item, index) => {
          const unitPrice = parseFloat(item.price);
          const quantity = parseInt(item.quantity);
          const totalPrice = (unitPrice * quantity).toFixed(2);
          
          // 获取图片URL
          let imageUrl = 'https://cdn.shopify.com/s/files/1/0533/2089/files/placeholder-images-image_large.png';
          if (item.image && item.image.src) {
            imageUrl = item.image.src;
          }
          
          // 获取变体信息
          const variantTitle = item.variant_title ? item.variant_title : '';
          
          // 状态显示
          const status = item.fulfillment_status === 'fulfilled' ? t('shipped') : t('processing');
          
          orderInfoHTML += `
            <div class="order-item">
              <div class="product-col">
                <div class="product-info">
                  <div class="product-image">
                    <img src="${imageUrl}" alt="${item.title}" onerror="this.src='https://via.placeholder.com/60x60'">
                  </div>
                  <div class="product-details">
                    <div class="product-name">${item.title}</div>
                    ${variantTitle ? `<div class="variant-title">${t('size')}: ${variantTitle}</div>` : ''}
                    <div class="packaging">${t('packaging')}</div>
                    ${item.sku ? `<div class="sku">${t('sku')}: ${item.sku}</div>` : ''}
                  </div>
                </div>
              </div>
              <div class="quantity-col">×${quantity}</div>
              <div class="total-col">
                ${order.currency_code || order.currency ? `
                  ${item.compare_at_price && parseFloat(item.compare_at_price) > parseFloat(item.price) ? `
                    <div class="original-price">${order.currency} ${parseFloat(item.compare_at_price).toFixed(2)}</div>
                  ` : ''}
                  <div class="final-price">${order.currency} ${totalPrice}</div>
                ` : `
                  ${item.compare_at_price && parseFloat(item.compare_at_price) > parseFloat(item.price) ? `
                    <div class="original-price">£${parseFloat(item.compare_at_price).toFixed(2)}</div>
                  ` : ''}
                  <div class="final-price">£${totalPrice}</div>
                `}
              </div>
              <div class="status-col">
                <span class="status-badge ${item.fulfillment_status === 'fulfilled' ? 'shipped' : 'processing'}">${status}</span>
              </div>
            </div>
          `;
        });
      }
      
      // 添加订单汇总信息
      orderInfoHTML += `
          </div>
          
          <div class="order-summary">
            <div class="delivery-section">
              <h4>${t('deliveryAddress')}</h4>
              <div class="address-info">
                ${order.email ? `<div>${order.email}</div>` : ''}
                ${order.shipping_address ? `
                  <div>${order.shipping_address.first_name} ${order.shipping_address.last_name}</div>
                  <div>${order.shipping_address.phone || ''}</div>
                  <div>${order.shipping_address.address1}</div>
                  ${order.shipping_address.address2 ? `<div>${order.shipping_address.address2}</div>` : ''}
                  <div>${order.shipping_address.city}, ${order.shipping_address.province_code || order.shipping_address.province || ''} ${order.shipping_address.zip}</div>
                  <div>${order.shipping_address.country}</div>
                ` : ''}
              </div>
            </div>
            
            <div class="payment-section">
              <h4>${t('payment')}</h4>
              <div class="payment-info">
               
                <div class="payment-row">
                  <span>${t('productAmount')}</span>
                  <span>${order.currency || '£'} ${parseFloat(order.subtotal_price).toFixed(2)}</span>
                </div>
                
                ${parseFloat(order.total_discounts) > 0 ? `
                <div class="payment-row">
                  <span>${t('discount')}</span>
                  <span>- ${order.currency || '£'} ${parseFloat(order.total_discounts).toFixed(2)}</span>
                </div>
                ` : ''}
                
                ${order.shipping_lines && order.shipping_lines.length > 0 ? `
                <div class="payment-row">
                  <span>${t('shipping')}</span>
                  <span>${order.currency || '£'} ${parseFloat(order.shipping_lines[0].price).toFixed(2)}</span>
                </div>
                ` : ''}
                
                <div class="payment-row">
                  <span>${t('totalAmount')}</span>
                  <span>${order.currency || '£'} ${parseFloat(order.total_price).toFixed(2)}</span>
                </div>
              </div>
            </div>
          </div>
      `;
      
  
      
      orderInfoHTML += `</div>`;
      
      resultDiv.innerHTML = orderInfoHTML;
      
      // 如果有追踪号，自动在当前页面展示追踪信息
      if (trackingNumber) {
        trackInOrderTab(trackingNumber);
      }
    } else {
      resultDiv.innerHTML = `
        <p class="error-message">
          ${t('noOrderFound')}
        </p>
      `;
    }
  } catch (error) {
    resultDiv.innerHTML = `
      <p class="error-message">
        ${t('errorOccurred')}
      </p>
    `;
    console.error("Error:", error);
  }
}

// 追踪包裹的功能
function doTrack() {
  // 检查YQV5是否已加载
  if (typeof YQV5 === 'undefined') {
    console.error('YQV5 追踪脚本未加载，无法追踪包裹');
    document.getElementById("YQContainer").innerHTML = `<p class="error-message">${t('errorOccurred')} (YQV5 script not loaded)</p>`;
    return;
  }

  var num = document.getElementById("YQNum").value;
  if(num === "") {
    document.getElementById("YQContainer").innerHTML = `<p class="error-message">${t('enterTrackingNumber')}</p>`;
    return;
  }
  document.getElementById("YQContainer").innerHTML = `<div class="loading-indicator">${t('loadingTracking')}</div>`;
  YQV5.trackSingle({
    YQ_ContainerId: "YQContainer",
    YQ_Height: 560,
    YQ_Fc: "0",
    YQ_Lang: typeof currentLang !== 'undefined' ? currentLang : 'en',
    YQ_Num: num
  });
}

// 在订单页面内直接追踪包裹
function trackInOrderTab(trackingNumber) {
  // 检查YQV5是否已加载
  if (typeof YQV5 === 'undefined') {
    console.error('YQV5 追踪脚本未加载，无法追踪包裹');
    document.getElementById('embedded-tracking').style.display = 'block';
    document.getElementById('embedded-YQContainer').innerHTML = 
      `<p class="error-message">${t('errorOccurred')} (YQV5 script not loaded)</p>`;
    return;
  }

  document.getElementById('embedded-tracking').style.display = 'block';
  document.getElementById('embedded-YQContainer').innerHTML = 
    `<div class="loading-indicator">${t('loadingTracking')}</div>`;
  
  YQV5.trackSingle({
    YQ_ContainerId: "embedded-YQContainer",
    YQ_Height: 560,
    YQ_Fc: "0",
    YQ_Lang: typeof currentLang !== 'undefined' ? currentLang : 'en',
    YQ_Num: trackingNumber
  });
}

// 获取Shopify商店信息
function getShopifyInfo() {
  const shopInfo = {
    domain: 'kj39da-y0.myshopify.com', // 默认域名
    storeId: '0624/0793/4017', // 默认ID
  };
  
  // 尝试从Shopify全局变量获取商店域名
  if (typeof Shopify !== 'undefined' && Shopify.shop) {
    shopInfo.domain = Shopify.shop;
   console.log(`检测到Shopify商店: ${shopInfo.domain}`);
  }
  
  return shopInfo;
}